export const getTabsContainerStyle = theme => ({
  width: 420,
  minWidth: 420,
  paddingLeft: 24,
  paddingRight: 16,
  height: "100%",
  display: "flex",
  flexDirection: "column",
  flexWrap: "nowrap",
  borderLeft: theme.palette.thickSeperator,
  zIndex: 500
});